<!--
 * @Author: 鸦雀銮翎
 * @Date: 2023-01-11 14:35:07
 * @LastEditTime: 2024-03-15 16:48:38
 * @Description:
 * @FilePath: \website\src\components\BottomFoot.vue
 * 可以输入预定的版权声明、个性签名、空行等
-->
<template>
    <div class="foot-bg">
        <div class="text-block">
            <br>
            <div>
                Copyright © 2019 www.tudouec.com All Right Reserved 中国薯网版权所有
            </div>
            <div>
                声明：本站信息仅供参考，未经允许不得私自用作商业用途、若要转载，请注明出处。
            </div>
            <div class="beian">
                <a
                    target="_blank"
                    href="https://beian.miit.gov.cn/#/Integrated/recordQuery"
                >
                    蒙ICP备 2023001296号-1
                </a>
                <span>|</span>
                <a
                    target="_blank"
                    href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=15010502000590"
                >
                    <img src="http://wwwadm.tudouec.com/profile/resource/www_img/beian.png" style="float: left" />
                    蒙公网安备 15010502000590号
                </a>
            </div>
        </div>
        <div class="text-block">
            <div>中国薯网·内蒙古金豆农业科技有限公司</div>
            <div>地址：内蒙古呼和浩特市赛罕区金桥电子商务产业园403室</div>
            <div>网址：www.tudouec.com 邮箱：tudouec@163.com</div>
            <div>中国薯网热线电话 0471-3371777</div>
        </div>
        <div class="text-block">
            <img width="66px" src="http://wwwadm.tudouec.com/profile/resource/www_img/qrcode.jpg" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomFoot",
    data() {
        return {};
    },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/public.scss";
/deep/.foot-bg {
    @include body-padding();
    background-image: url("http://wwwadm.tudouec.com/profile/resource/www_img/footer.png");
    background-size: cover;
    height: 324px;
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    bottom: 0;
    .text-block {
        div {
            color: #ffffff;
        }
        margin-top: 137px;
        flex-basis: 40%;
    }
    :first-child {
        flex-basis: 50%;
    }
    :last-child {
        flex-basis: 10%;
        align-self: bottom;
    }

    .beian {
        display: flex;
        justify-content: start;
        align-content: center;

        a {
            color: #ffffff;
            flex-basis: auto;
        }
        span {
            margin: 0 5px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/BottomFoot.vue